import App from './App.vue';
import router from './router';
import { createApp } from 'vue';
import { start_session_timeout_monitor } from './utils/session_timeout_monitor';

// Import Bootstrap (includes Popper via the bundle)
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

// Import Font Awesome
import "@fortawesome/fontawesome-free/css/all.css";
 
// Import Bootstrap Icons
import "bootstrap-icons/font/bootstrap-icons.css"; 
 
// Import custom CSS
import './assets/style/style.css';
 
 
const jquery_instance = window.jQuery || window.$;

if (jquery_instance) {
  jquery_instance(document).ajaxComplete(function(event, xhr) {
    if (xhr.status === 401) {
      router.push("/");
    }
  });
}
 
createApp(App).use(router).mount('#app');
start_session_timeout_monitor(router);
 
